<script setup>
// Aceleres -- figurinha vetorial do WhatsApp (as animadas, as de avatar e as
// de IA). Nao existe imagem nenhuma para mostrar: o WhatsApp guarda a
// animacao em Lottie, e e o proprio aparelho que a desenha. O desenho em si
// vive em LottieStickerCanvas, compartilhado com a miniatura da citacao; aqui
// fica so a bolha em volta.
import { computed, defineAsyncComponent, ref } from 'vue';
import BaseBubble from './Base.vue';
import LottieStickerCanvas from './LottieStickerCanvas.vue';
import { useMessageContext } from '../provider.js';
import { useSnakeCase } from 'dashboard/composables/useTransformKeys';

// Aceleres 2026-08-17: assincrono para o visor nao entrar no pacote de toda
// bolha de figurinha — ele so faz falta depois do clique.
const GalleryView = defineAsyncComponent(
  () =>
    import(
      'dashboard/components/widgets/conversation/components/GalleryView.vue'
    )
);

const { attachments, id: messageId } = useMessageContext();

const animationUrl = computed(() => attachments.value?.[0]?.dataUrl || '');

// Aceleres 2026-08-17: a figurinha vetorial passou a ABRIR no visor, como a
// de imagem. Ate aqui esta bolha nao tinha clique nenhum — era o "alguns
// stickers nao abrem" relatado. Abre sozinha, sem as outras midias da
// conversa, pela mesma regra da figurinha webp (ver `galleryAttachments` em
// Image.vue).
const showGallery = ref(false);

const galleryAttachment = computed(() => {
  const raw = attachments.value?.[0];
  if (!raw) return null;

  // Aceleres 2026-08-17: o `message_id` vai JUNTO, e nao por acaso. O visor
  // resolve o autor (e as acoes) procurando a mensagem por este id; sem ele
  // caia no rotulo de contacto desconhecido, que foi o "aparece como se o
  // enviasse um contacto estranho" relatado. A bolha de imagem nao sofria disto
  // porque entrega a lista de anexos da conversa, que ja traz o id.
  return {
    ...useSnakeCase(raw),
    message_id: raw.messageId ?? raw.message_id ?? messageId.value,
  };
});
</script>

<template>
  <BaseBubble
    class="acl-sticker-bubble max-w-[min(320px,70vw)] p-0"
    show-sender-name
    data-bubble-name="sticker"
    role="button"
    tabindex="0"
    @click="showGallery = true"
    @keydown.enter.space.self.prevent="showGallery = true"
  >
    <!-- A moldura repete a do sticker de imagem (`.acl-sticker-bubble
         div.relative`, em aceleres-pill-icons.css): assim a animacao nasce do
         mesmo tamanho que as figurinhas comuns, sem medida propria para
         manter em dia. -->
    <LottieStickerCanvas
      v-if="animationUrl"
      :url="animationUrl"
      class="relative"
      replay-on-hover
    />
  </BaseBubble>

  <GalleryView
    v-if="showGallery && galleryAttachment"
    v-model:show="showGallery"
    :attachment="galleryAttachment"
    :all-attachments="[galleryAttachment]"
    is-sticker
    @close="() => (showGallery = false)"
  />
</template>
